import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderLayout from '../../../Layout/HeaderLayout';
import { useDispatch, useSelector } from 'react-redux';
import { IState, actions } from '../../../Store/reducer';
import { redirectWithBoolean } from '../../../Components/RedirectPlayer/RedirectPlayer';
import Dice from '../../../Components/Dice/Dice';
import { CONFIG_PLAYER_PATH } from '../../../Services/routeNames';
import species from '../../../Services/species';
import archetypes from '../../../Services/archetypes';
import { PlainBox } from '../../../Components/PlainBox';
import characters from '../../../Services/characters';
import './characterHpPlayer.scss';

function CharacterHp() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { level, currentHp, hpMax, characterInfo } = useSelector((state: IState) => state.player);
    const article = () => species[characterInfo.species].gender === "female" ? "la " : "le ";
    const archetype = () => archetypes[characterInfo.archetype].name[species[characterInfo.species].gender].toLowerCase();
    const updateHp = (hp: number) => dispatch({ type: actions.player.SET_CURRENT_HP, payload: { player: { currentHp: Math.max(0, currentHp + hp) } } });

    const character = characters[characterInfo && characterInfo.name.toLowerCase()] ?? { background: "#cb9e4b" };
    const opacity = (80 * currentHp / hpMax / 100) + .2;

    useEffect(() => redirectWithBoolean(level === -1, CONFIG_PLAYER_PATH, navigate), [level, navigate]);

    return (
        <div className="character-hp">
            {level !== -1 && characterInfo && currentHp !== -1 && hpMax !== -1 &&
                <>
                    <HeaderLayout currentPage="hp" hamburger={true} isPlayer={true}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 127.78 100"><g><path fill="#fff" d="m63.89,16.26C28.75-23.54-21.23,17.48,9.67,56.37c11.38,14.32,26.98,23.43,53.96,43.44l.12.09s.09.06.13.1c27.15-20.14,42.8-29.26,54.22-43.63,30.91-38.89-19.08-79.91-54.22-40.12Zm45.14,22.48c2.56-4.83.09-10.88-4.54-12.92,0,0,2.91-4.11,2.91-4.11,4.91,4.23,6.16,12.42,1.63,17.03Z" /></g></svg>
                        <span>Points de vie</span>
                    </HeaderLayout>

                    <div className="character-box" style={{ backgroundImage: 'url(/image/character-box.png)' }}>
                        <div className="character-name">
                            <PlainBox fill={character.background} />
                            <span>{characterInfo.name + ", " + article() + " " + characterInfo.species + " " + archetype()}</span>
                        </div>
                        <div className="character-details">
                            <img className="character-image" src={species[characterInfo.species].image} alt={'Image ' + species[characterInfo.species].image} />
                            <div className="hp-button noselect" onClick={() => updateHp(-1)}>-</div>
                            <div className="hp-value">
                                <svg style={{ opacity: opacity }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 127.78 100"><g><path fill="#513322" d="m63.89,16.26C28.75-23.54-21.23,17.48,9.67,56.37c11.38,14.32,26.98,23.43,53.96,43.44l.12.09s.09.06.13.1c27.15-20.14,42.8-29.26,54.22-43.63,30.91-38.89-19.08-79.91-54.22-40.12Zm45.14,22.48c2.56-4.83.09-10.88-4.54-12.92,0,0,2.91-4.11,2.91-4.11,4.91,4.23,6.16,12.42,1.63,17.03Z" /></g></svg>
                                <span>{currentHp} / {hpMax}</span>
                            </div>
                            <div className="hp-button noselect" onClick={() => updateHp(+1)}>+</div>
                        </div>
                    </div>

                    <div className="character-dice">
                        <Dice nbSides={20} />
                    </div>
                </>
            }
        </div>
    );
}

export default CharacterHp;